import { Icon } from '@iconify/react';
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';
// utils
import { fShortenNumber } from 'utils/formatNumber';
import { RootState, useSelector } from 'redux/store';
import useLocales from 'hooks/useLocales';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.error.darker,
  backgroundColor: theme.palette.error.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.error.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.error.dark, 0)} 0%, ${alpha(
    theme.palette.error.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

const TOTAL = 300000400;

export default function FinanicalTransactions() {
  const { translate } = useLocales();
  const { transationsCount } = useSelector(
    (state: RootState) => state.transactionCount
);
  return (
    <RootStyle>
      <Typography variant="h3">{fShortenNumber(transationsCount.fyTransactions)}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
      {translate(`dashboard.${"This FY Transactions"}`)}
      </Typography>
    </RootStyle>
  );
}